import { PDFDownloadLink } from "@react-pdf/renderer";
import React from "react";
import GlobalTable from "../../../components/global-table";
import { Button, InputField, Typography } from "../../../ppui";
import {  ContentLayout, ContentTable } from "../../style";
// import { SalaryHeaders } from "./esireport.data";
// import { logger } from "../../../utils/logger";
import { getMonthInStringNotOneIndexBased } from "../../../utils/common";
import { SalaryHeaders } from "./esi-report-data";
import ESIPdf from "./pdf-report";
import useESIReportService from "./use-esi-report-service";

function EsiReport() {
  // const {
  //   salarylistdata,
  //   rowsPerPage,
  //   currentPage,
  //   totalPages,
  //   handleNextPage,
  //   handlePreviousPage,
  //   handleRowsPerPageChange,
  //   searchQuery,
  //   setSearchQuery,
  //   // setUserinfo,
  //   // useInfo,
  //   serchinfo,
  //   setSearchinfo,
  //   extarnalinfo,
  //   // getList,
  // } = EsiReportServices()
  const {
    ESIReportListData,
    esiReportInputs,
    handleChange,
    dataFetched,
    handleExportClick,
    loadingAllESIReport,
    esiReportPDFData,
    esiReportSummary,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    organizationInfo,
  } = useESIReportService();

  const orgInitials = organizationInfo?.org_name?.split(' ').map(word => word[0]?.toUpperCase()).join('');

  return (
    <>
      <ContentLayout>
        {/* <ContentHeading></ContentHeading> */}
        <ContentTable>
          <GlobalTable
            headers={SalaryHeaders(currentPage, rowsPerPage)}
            rows={ESIReportListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={true}
            avatar={true}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            stickyHeader="true"
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                  {/* {`ESI Report of ${getMonthInStringNotOneIndexBased(esiReportPDFData[0]?.month)} ${esiReportPDFData[0]?.year}`} */}
                  {/* {dataFetched && esiReportSummary?.total_esi_member}  */}
                  ESI Report{" "}
                  {(dataFetched && ESIReportListData.length > 0) &&
                    `of ${getMonthInStringNotOneIndexBased(esiReportPDFData[0]?.month)} ${esiReportPDFData[0]?.year}`}
                </Typography>
              </>
            }
            actionRight={
              <>
                <InputField
                  label="Report Month"
                  name="month"
                  type="month"
                  placeholder="Type Here..."
                  valueSinc
                  value={esiReportInputs?.report_month}
                  onChange={(e) => handleChange(e.target.value, "report_month")}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {dataFetched ? (
                  <PDFDownloadLink
                    document={
                      <ESIPdf
                        // ESIReportListData={ESIReportListData}
                        // extarnalinfo={extarnalinfo}
                        esiReportPDFData={esiReportPDFData}
                        esiReportSummary={esiReportSummary}
                        organizationInfo={organizationInfo}
                      />
                    }
                    fileName={`${orgInitials}-esi-report.pdf`}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleExportClick}
                      loading={loadingAllESIReport}
                      disabled={ESIReportListData.length > 0 ? false : true}
                    >
                      Export
                    </Button>
                  </PDFDownloadLink>
                ) : (
                  <Button color="primary" variant="contained" disabled={true}>
                    Export
                  </Button>
                )}
              </>
            }
          />
        </ContentTable>
      </ContentLayout>
    </>
  );
}

export default EsiReport;
